import { useMemo, useRef, useState } from 'react'
import { useClickAway } from 'react-use'
import { ButtonArea, Container, Dropdown, Search } from './styles'
import { IoIosArrowDown } from 'react-icons/io'
import { FiSearch } from 'react-icons/fi'
import { useUncontrolled } from '../../hooks/use-uncontrolled'
import Fuse from 'fuse.js'
import { useDebouncedState } from '../../hooks/use-debounced-state'
import OptionsList from './OptionsList'

export interface IOption {
  value: string | number
  label: string

  title?: string
  customSearchKey?: string
}

interface ISeachMultiselectProps {
  options: IOption[]

  label?: string

  selected?: IOption[]
  onChange?(value: IOption[]): void
  defaultValue?: IOption[]

  disabled?: boolean
  loading?: boolean

  className?: string

  hideSearchBar?: boolean
}

const SearchMultiselect = (props: ISeachMultiselectProps) => {
  const containerRef = useRef<HTMLDivElement>(null)

  const [search, debouncedSetSearch, setSearch] = useDebouncedState('', 500)

  const [displayDropdown, setDisplayDropdown] = useState(false)
  const [selected, onChange] = useUncontrolled({
    value: props.selected,
    defaultValue: props.defaultValue,
    finalValue: [],
    onChange: props.onChange,
  })
  useClickAway(containerRef, () => {
    setDisplayDropdown(false)
  })

  const isEmpty = props.options.length === 0

  const stopPropagation = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => e.stopPropagation()

  const toggle = () => {
    if (props.disabled) return
    if (props.loading) return
    if (isEmpty) return

    setDisplayDropdown((state) => {
      const willClose = state === true

      if (willClose) {
        setSearch('')
      }

      return !state
    })
  }

  const onInputMount = (inputEl: HTMLInputElement | null) => {
    if (inputEl && window.innerWidth > 800) {
      inputEl.focus()
    }
  }

  const filteredOptions = useMemo(() => {
    if (!search) return props.options

    const fuse = new Fuse(props.options, {
      keys: [
        { name: 'label', weight: 1 },
        { name: 'customSearchKey', weight: 10 },
      ],
      threshold: 0.3,
    })

    return fuse.search(search)
  }, [search, props.options])

  return (
    <Container onClick={toggle} ref={containerRef} className={props.className}>
      <ButtonArea
        disabled={props.disabled || isEmpty}
        $loading={props.loading}
        className="multiSelect-buttonarea"
      >
        <div className="wrap">
          <p className="label" title={props.label || 'Selecionar'}>
            {props.label || 'Selecionar'}
          </p>
        </div>

        <IoIosArrowDown size={16} />
      </ButtonArea>

      {displayDropdown && (
        <Dropdown onClick={stopPropagation}>
          {!props.hideSearchBar && (
            <Search>
              <div className="icon">
                <FiSearch size={16} />
              </div>

              <input
                type="text"
                placeholder="Buscar"
                onChange={(e) => debouncedSetSearch(e.target.value)}
                ref={onInputMount}
              />
            </Search>
          )}

          <OptionsList options={filteredOptions} selected={selected} onChange={onChange} />
        </Dropdown>
      )}
    </Container>
  )
}

export default SearchMultiselect
